import { useGetVIPList, useGetProgramDetail } from '../context/useQuery'
import * as Component from 'src/feature/bite/component'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useVIP } from '../hook'
import { useStartManuelProcess } from '../context/useMutation'

import VIPList from '../component/List'
import ProgramStatus from './data/ProgramStatus'
import ProgramBody from './data/ProgramBody'

function Vip() {
  const { program, prevProgram } = useVIP()
  const { isLoading, refetch: listRefetch } = useGetVIPList()
  const { isLoading: isProgramLoading, refetch } = useGetProgramDetail()
  const { mutateAsync: startManuelProcess } = useStartManuelProcess()

  const intl = useIntl()
  const navigate = useNavigate()

  return (
    <>
      <Component.Breadcrumb currentPage={intl.formatMessage({ id: 'VIP.TIERS' })} />
      <ProgramStatus refetch={refetch} />
      <div className='card mt-10'>
        <div className='card-header border-0'>
          <div className='card-title d-flex flex-column'>
            <div className='d-flex align-items-center position-relative my-1'>
              {intl.formatMessage({ id: 'VIP.TIERS' })}
            </div>
            <span className=' fs-6 text-muted'>{intl.formatMessage({ id: 'VIP.TIER.SUBTITLE' })}</span>
            <span className=' fs-6 text-muted'>{intl.formatMessage({ id: 'VIP.TIER.SUBTITLE.2' })}</span>
          </div>
          <div className='card-toolbar'>
            <button
              className='btn btn-primary'
              onClick={() => navigate('/vip/new-tier')}
              disabled={program?.processing || program?.status === 2 || false}
            >
              <i className='bi bi-plus fs-1 me-2'></i>
              {intl.formatMessage({ id: 'VIP.ADD.TIER' })}
            </button>
          </div>
        </div>
        <div className='card-body'>
          <VIPList
            loading={isLoading}
            refetch={listRefetch}
            isProgress={program?.processing || program?.status === 2 || false}
            entryMethodType={prevProgram?.entryMethodType || 1}
          />
        </div>
      </div>

      <h2 className='fs-1 mt-10 text-primary'>{intl.formatMessage({ id: 'VIP.PROGRAM.RULES' })}</h2>

      <div className='card mt-10'>
        <ProgramBody
          key={program?.id}
          loading={isProgramLoading}
          refetch={refetch}
          isProgress={program?.processing || program?.status === 2 || false}
        />
      </div>

      {program?.plannedProcessDateTime && (
        <div className='alert alert-info d-flex align-items-center p-8 mt-10'>
          <div className='d-flex flex-column'>
            <h5 className='mb-4'>
              {!program.processing ? (
                <>{intl.formatMessage({ id: 'VIP.PROGRAM.SCHEDULED' })} {new Date(program.plannedProcessDateTime).toLocaleString()}</>
              ) : (
                <>{intl.formatMessage({ id: 'VIP.PROGRAM.PROCESSING' })}</>
              )}
            </h5>
            <div>
              {program.processing ? (
                // <>VIP program is processing</>
                <>{intl.formatMessage({ id: 'VIP.PROGRAM.PROCESSING.DESC' })}</>
              ) : (
                <div className='d-flex flex-column align-items-start gap-4'>
                  <div style={{
                    fontStyle: 'italic',
                  }}>
                    {intl.formatMessage({ id: 'VIP.PROGRAM.SCHEDULED.DATE.NOTE' })}
                  </div>
                  <div>
                    {intl.formatMessage({ id: 'VIP.PROGRAM.SCHEDULED.DATE' })}
                  </div>
                  <button
                    className='btn btn-primary'
                    onClick={async () => {
                      await startManuelProcess()
                      refetch()
                    }}
                  >
                    {intl.formatMessage({ id: 'VIP.PROGRAM.START.PROCESS' })}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Vip
